export const tradesLocation = "/domestic/trades";
